import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import TextField from 'material-ui/TextField';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from "react-redux";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as actions from '../../actions/actions.jsx';
import creditcardlogo from "../../images/credit-cards-vector-icon-.jpg";
// import Loader from '../loader/loader.jsx'
import s from '../../services/allservices.jsx';
import '../../stylesheet/transfer.css';
import LeftLink from '../leftlink/leftlink.jsx';
import Loader from '../loader/loader.jsx';
import AuthNavbar from '../navigation/authnavigation.jsx';
import { getClientId, getClientSecret,buildClientHeader } from '../../utils/clientAuth.js'

const styles = {
    button: {
        margin: 12,
        background: "#2a5194"
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },

    focusTextStyle: {
        color: "#333"
    },
};

const mapStateToProps = state =>
({
    publicKey: state.publicKey.publicKey,
    keyRecieved: state.publicKey.keyRecieved,
    cardState: state.getCardReducer.cardState,
    display: state.getCardReducer.display,
    profileState: state.getProfileReducer.profileState,
    friendsState: state.getFriendsReducer.friendsState
})
const mapDispatchToProps = dispatch =>
({
    fetchPublicKey(keyRecieved) {
        dispatch(
            actions.publicKeyAction(keyRecieved)
        )
    },
    fetchCard(state) {
        dispatch(
            actions.getCardAction(state)
        )
    },
    fetchFriends() {
        dispatch(
            actions.getFriendsAction()
        )
    }
})
const JSEncrypt = window.JSEncrypt
class ShareFunds extends Component {
    state = {
        toAccount: 1,
        fromAccount: 1,
        transferFrequency: 1,
        amount: "",
        expDate: "",
        firstName: "",
        lastName: "",
        comment: "",
        disabled: true,
        loader: true,
        correctcomment: true,
        commentState: true,
        required: PropTypes.bool,
        amountState: true,
        correctamount: true,
        filteredToCards: [],
        filteredFromCards: [],
        Toggled: false,
    }
    componentDidMount() {
        this.setState({
            loader: true
        })
        const { publicKey } = this.props
        let _this = this
        
        setTimeout(function () {
            if (publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);


                const state = {
                    applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                    accountId: encrypt.encrypt(localStorage.getItem("accountId"))
                }

                _this.props.fetchCard(state)
                _this.props.fetchFriends();
            }
        }, 1000);
        this.setState({
            loader: false,
        })
    }
    removeamount = () => {
        this.setState({
            amountState: true
        })
    }

    onChangeamount = (e, value) => {
        if (e.target.name === "amount") {
            if (/^\d+(\.\d{1,2})?$/.test(e.target.value)) {
                this.setState({
                    correctamount: true,
                    amount: value,
                })
            } else {
                this.setState({
                    correctamount: false
                })
            }
        } else {
            this.setState({
                [e.target.name]: e.target.value
            })
        }

    }
    onChangecomment = (e, value) => {
        if (e.target.name === "comment") {
            if (/^[a-zA-Z]$/.test(e.target.value)) {
                this.setState({
                    correctcomment: true,
                    comment: value,
                })
            } else {
                this.setState({
                    correctcomment: false
                })
            }
        } else {
            this.setState({
                [e.target.name]: e.target.value
            })
        }

    }
    removecoment = () => {
        this.setState({
            commentState: true
        })
    }
    decimal = (amount) => {
        // var value = Number(amount);
        if (String(amount).split(".").length < 2 || String(amount).split(".")[1].length <= 2) {
            amount = amount.toFixed(2);
        }
        return amount;

    }

    onChange = (e, value) => {

        if (e.target.name === "comment") {


            if (e.target.name === "comment") {
                if (/^[a-zA-Z]$/.test(e.target.value)) {
                    this.setState({
                        correctcomment: true,
                        comment: value,
                    })
                } else {
                    this.setState({
                        correctcomment: false
                    })
                }
            }

            this.setState({
                [e.target.name]: e.target.value
            }, () => {

                const { amount, comment } = this.state

                if (amount !== "" && comment !== "") {

                    this.setState({
                        disabled: false
                    })
                } else {
                    this.setState({
                        disabled: true
                    })
                }
            })
        }

    }


    handleSelect1 = (event, index, value) => {
        this.setState({ fromAccount: value });
    }
    handleSelect2 = (event, index, value) => {
        this.setState({ toAccount: value });
    }
    handleSelect3 = (event, index, value) => {
        this.setState({ transferFrequency: value });
    }
    componentWillReceiveProps(nextProps) {
        this.setState({
            loader: true
        })
        try {

            if (nextProps.cardState && nextProps.cardState.length !== 0) {

                var filteredFromR = nextProps.cardState.body.filter((val) => {
                    return (val.cardType === "R")
                })
                var filteredFromCards = filteredFromR
                this.setState({
                    loader: false,
                    fromAccount: filteredFromCards[0].cardDetailsId,
                    selectedCard: filteredFromCards[0],
                    filteredFromCards: filteredFromCards
                })
            }
            // if (nextProps.cardState && nextProps.cardState.length !== 0) {
            //     this.setState({
            //         loader: false,
            //         fromAccount: nextProps.cardState.body[0].cardDetailsId
            //     })
            // }
            if (nextProps.friendsState && nextProps.friendsState.length !== 0) {
                this.setState({
                    loader: false,
                    toAccount: nextProps.friendsState.body[0].cardDetailsId,
                    selectedCard: nextProps.friendsState.body[0],
                    filteredToCards: nextProps.friendsState.body
                })
            }
        } catch (e) {

        }
    }
    handleFriends() {
        this.props.history.push("/friends&family")
    }
    refreshpage=()=> {
        this.setState({
            Toggled: !this.state.Toggled
        })
    }
    handleSubmit = () => {
        const { amount, correctamount } = this.state
        if (amount === "") {
            this.setState({
                amountState: false,
            })
        }
        else if (correctamount === false) {
            this.setState({
                correctamount: false,
            })
        }


        else if (this.state.comment === "") {
            this.setState({
                commentState: false,
            })
        }
        else {
            const { friendsState } = this.props
            let firstName, lastName
            try {
                for (let i = 0; i <= friendsState.body.length; i++) {
                    if (friendsState.body[i].cardDetailsId === this.state.toAccount) {
                        firstName = friendsState.body[i].firstName
                        lastName = friendsState.body[i].lastName
                    }
                }
            } catch (e) {

            }

            const { publicKey } = this.props
            if (publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);
                let state = {
                    amount: encrypt.encrypt(this.state.amount),
                    applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                    firstName: encrypt.encrypt(firstName),
                    fromCardDetailsId: encrypt.encrypt(this.state.fromAccount),
                    lastName: encrypt.encrypt(lastName),
                    toCardDetailsId: encrypt.encrypt(this.state.toAccount),
                    comments: encrypt.encrypt(this.state.comment)
                }
                let token = "Token " + localStorage.getItem('token')
                if (this.state.toAccount !== this.state.fromAccount) {
                    let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
                    let traceId = getClientId();
                    fetch(plink + s.share_fund , {
                        method: 'POST',
                        headers: new Headers({
                            'Content-Type': 'application/json',
                             'Authorization': token,
                             'X-Trace-Id': traceId,
                             'X-Client-APP':buildClientHeader(),
                        }),
                        body: JSON.stringify(state)
                    })
                        .then(response => {
                            if (response.status === 200 || response.status === 201 || response.status === 204) {
                                toast.success(response.headers.get('message'), {
                                    position: "top-right",
                                    draggablePercent: 60,
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: false
                                });

                                setTimeout(function () { window.location.reload(true); }, 1000);

                            }
                            else if (response.status === 422) {
                                if (response.json().length > 0) {
                                    response.json()
                                        .then(json => {
                                            let message = json.message ? json.message : response.headers.get('message')
                                            //document.getElementById('setpassword').style.display = "block"
                                            toast.error(message, {
                                                position: "top-right",
                                                autoClose: 3000,
                                                hideProgressBar: false,
                                                closeOnClick: true,
                                                pauseOnHover: true,
                                                draggable: true,
                                                draggablePercent: 60
                                            })
                                        })
                                }
                                else {
                                    let message = response.headers.get('message')
                                    //document.getElementById('setpassword').style.display = "block"
                                    toast.error(message, {
                                        position: "top-right",
                                        autoClose: 3000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        draggablePercent: 60
                                    })
                                }
                            }
                            else {
                                toast.error(response.headers.get('message'), {
                                    position: "top-right",
                                    draggablePercent: 60,
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: false
                                });


                            }
                        })
                } else {
                    toast.error("You cant transfer funds to same card account", {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                }
            }
        }
    }
    render() {
        const { cardState, friendsState } = this.props
        const { fromAccount, toAccount, amountState, correctamount, commentState, filteredFromCards, filteredToCards } = this.state
        return (
            <div>
                <ToastContainer
                    draggablePercent={60}
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable={false}
                    pauseOnHover
                />
                <div className="row">
                    <div className="col-sm-12 p-0 m-0">
                        <AuthNavbar />
                    </div>

                </div>
                <div className="container" style={{  }}>
                    <div className="row">
                        {/* <div className="col-sm-3 box-shadow-style nopadding" style={{ minHeight: "470px" }}>
                            <LeftLink />
                        </div> */}
<div className="modal fade" id="shareFundModal" role="dialog">
	<div className="modal-dialog ">
		<div className="modal-content " style={{ marginTop: "150px", background: "rgb(214, 70, 84)" }}>
			<div className="modal-header" style={{ padding: "3px", borderBottom: "none", height: "45px" }}>
				<div className="col-sm-12" style={{ marginTop: "7px" }}>
					<div className="row">
						<div className="col-sm-6" style={{ fontSize: "19px", fontWeight: "600", color: "rgb(255, 255, 255)" }}>
							<span>Transfer Funds</span>
						</div>
						<div className="offset-4 col-sm-2" style={{ float: "right", color: "rgb(119, 119, 119)" }}>
							<button type="button" onClick={this.refreshpage} className="close" data-dismiss="modal">&times;</button>
						</div>
					</div>
				</div>

			</div>
			<div class="modal-body text-center" style={{ backgroundColor: "#fff" }}>
				<div className="col-sm-12" >
					<i className="fa fa-question fa-4x mb-3 animated rotateIn" style={{ color: "rgb(214, 70, 84)" }}></i>
				</div>
				<div className="col-sm-12" style={{ fontSize: "20px" }}>
					<span>Are you sure, you want to share fund? </span>
				</div>
				<div className="col-sm-12" >
					<button type="button" className="btn btn-std" onClick={this.refreshpage} style={{ marginRight: "10px", backgroundColor: "#fff", fontSize: "13px", fontWeight: "bold", marginTop: "8px", border: "2px solid rgb(119, 119, 119)" }} data-dismiss="modal">Cancel</button>
					<button type="button" className="btn btn-std" style={{ fontSize: "13px", fontWeight: "bold", marginTop: "8px", border: "2px solid rgb(214, 70, 84)" }} onClick={this.handleSubmit.bind(this)} data-dismiss="modal">Ok</button>
				</div>
			</div>

		</div>
	</div>
</div>								
								
                        <div className="col-sm-12" style={{ padding: "0px 30px" }}>

                            <div className="row " style={{ padding: "12px 0px", minHeight: "476px" }}>
                                <div className="col-sm-12 m-0 p-0">
                                    <div className="header-style" style={{ padding: "5px 20px 0px 15px" }}>
                                        <h4 className='logmainheading mainheading'>
                                            Share Funds
                                        </h4>
                                        <p>
                                            Transfer funds from one card to another by filling in the Transfer Detail fields shown below. The amount entered in the Transfer Detail will be automatically transferred to the card selected when you click Transfer. Fields marked with * must be filled.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    {cardState.status === 200 && friendsState.status === 200 ?

                                        <div className="">
                                            {(friendsState.body.length !== 0) ?
                                                <div className="">
                                                    <div className="transfer-detail-header">
                                                        <h5>Transfer Details</h5>
                                                    </div>
                                                    <div className="transfer-detail-body">

                                                        <div className="row input-group" >
                                                            <div className="col-sm-6">
                                                                <div className="row">
                                                                    <div className="col-sm-12" >
                                                                        {cardState.status === 200 && cardState.body.length !== 0 && filteredFromCards.length !== 0 &&
                                                                            <SelectField
                                                                                floatingLabelText="Card Account (From) "
                                                                                onChange={this.handleSelect1}
                                                                                className="required"
                                                                                name="fromAccount"
                                                                                autoComplete='none'
                                                                                value={fromAccount}

                                                                            >
                                                                                {filteredFromCards.map((value, i) =>
                                                                                    <MenuItem className="menuitem" value={filteredFromCards[i].cardDetailsId} primaryText={filteredFromCards[i].cardNumber} key={i} />
                                                                                )}


                                                                            </SelectField>}
                                                                    </div>
                                                                </div>

                                                            </div>

                                                            <div className="col-sm-6">
                                                                <div className="row">
                                                                    <div className="col-sm-12" >
                                                                        {friendsState.status === 200 && friendsState.body.length !== 0 && filteredToCards.length !== 0 &&
                                                                            <SelectField
                                                                                required
                                                                                floatingLabelText="Card Account (To)"
                                                                                onChange={this.handleSelect2}
                                                                                autoComplete='none'
                                                                                className="required"
                                                                                name="toAccount"
                                                                                value={toAccount}

                                                                            >
                                                                                {filteredToCards.map((value, i) =>
                                                                                    <MenuItem className="menuitem" value={filteredToCards[i].cardDetailsId} primaryText={filteredToCards[i].cardNumber} key={i} />
                                                                                )}
                                                                            </SelectField>

                                                                        }
                                                                    </div>

                                                                </div>

                                                            </div>
                                                            <div className="col-sm-6">
                                                                <div className="row">
                                                                    <div className="col-sm-12 " >

                                                                        <TextField
                                                                            required
                                                                            floatingLabelText="Amount"
                                                                            type="text"
                                                                            name="amount"
                                                                            className="required"
                                                                            maxLength="10"
                                                                            autoComplete='off'
                                                                            onFocus={this.removeamount}
                                                                            onChange={this.onChangeamount}
                                                                            step="0.01"
                                                                            underlineFocusStyle={styles.focusStyle}
                                                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                                                            errorText={amountState ? correctamount ? null : "Not a valid amount" : "This field is required"}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {/* <div className="col-sm-6">
                                                <div className="row">
                                                    <div className="col-sm-2 input-icon" >
                                                        <img src={frequencyimg} alt="F" />
                                                    </div>
                                                    <div className="col-sm-10" >
                                                        <SelectField
                                                            floatingLabelText="Transfer Frequency "
                                                            onChange={this.handleSelect3}
                                                            className="input-width"
                                                            name="transferFrequency"
                                                            value={this.state.transferFrequency}
                                                        >
                                                            <MenuItem value={1} primaryText="One Time, Right Now" />
                                                            <MenuItem value={2} primaryText="One Time, On Specific Date" />
                                                            <MenuItem value={3} primaryText="Weekly" />
                                                            <MenuItem value={4} primaryText="Every Two Weeks" />
                                                            <MenuItem value={5} primaryText="Monthly" />
                                                            <MenuItem value={6} primaryText="Every Three Months" />
                                                            <MenuItem value={7} primaryText="Every Six Months" />
                                                            <MenuItem value={8} primaryText="Yearly" />
                                                        </SelectField>
                                                    </div>
                                                </div>

                                            </div> */}
                                                            <div className="col-sm-6">
                                                                <div className="row">
                                                                    <div className="col-sm-12" >
                                                                        <TextField
                                                                            hintText="Write Your Comment"
                                                                            floatingLabelText="Comments"
                                                                            multiLine={true}
                                                                            className="input-width required"
                                                                            maxLength="60"
                                                                            name="comment"
                                                                            autoComplete='none'
                                                                            onChange={this.onChange}
                                                                            onFocus={this.removecoment}
                                                                            underlineFocusStyle={styles.focusStyle}
                                                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                                                            errorText={commentState ? null : "This field is required"}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-6" style={{ marginTop: "50px" }}>
                                                                <RaisedButton
                                                                    label="Transfer Now"
                                                                    disabled={this.state.disabled}
                                                                    className="btn-std"
                                                                    // style={styles.button}
                                                                    backgroundColor="#FFCE39"
                                                                    labelColor="#115876"
                                                                    // onClick={this.handleSubmit}
                                                                    data-toggle="modal"
                                                                    data-target="#shareFundModal"
                                                                // icon={<i className="fa fa-search" aria-hidden="true" style={{ color: "#fff" }}></i>}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                <div className="nopadding" style={{ marginTop: "-140px" }}>
                                                    <div className="transfer-detail-header">
                                                        <h5>Transfer Details</h5>
                                                    </div>
                                                    <div className="col-sm-12 transfer-detail-body nopadding" style={{ marginTop: "15px", }}>
                                                        <div className="row">
                                                            <div className="col-sm-12">
                                                                <span style={{ fontSize: "16px" }} >
                                                                    To transfer funds you need one additional card.
                                                                </span>
                                                            </div>
                                                            <div className="col-sm-12" style={{  marginTop: "20px" }}>

                                                                <RaisedButton
                                                                    label="Add Card"
                                                                    className="btn-std"
                                                                    backgroundColor="#FFCE39"
                                                                    labelColor="#115876"
                                                                    style={{ minWidth: "50px", marginTop: "20px" , borderRadius :"6px"}}
                                                                    onClick={this.handleFriends.bind(this)}
                                                                // icon={<i className="fa fa-search" aria-hidden="true" style={{ color: "#fff" }}></i>}
                                                                />

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            }

                                        </div>

                                        : <Loader />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ShareFunds.defaultProps = {
    cardState: {
        status: 600
    },
    friendsState: {
        status: 600
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ShareFunds);


// WEBPACK FOOTER //
// ./src/components/transferfunds/sharefunds.jsx